"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Document = void 0;
var rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
Object.defineProperty(exports, "Document", { enumerable: true, get: function () { return rpdf_renderer_1.Document; } });
//# sourceMappingURL=document.js.map